import {chunk, compact, filter, inRange, includes, isEmpty, map, range, some, sum} from "lodash"
import {ChampionshipBetPick, ChampionshipBetTeam, PickValue, TChampionshipBet, TeamId} from "./types"

// indies:[ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10,11,12,13,14,15,16,17,18,19,20,21]
// usage :[w1,w1,w1,w1,w1,w2,w2,w2,w2,r3,r3,r3,r3,r3,r3,r3,r3,r3,r3,r3,r3,r3]
// When indicies change, adjust the following files accordingly:
// betty/use_cases/ranking/round_summary.rb
// betty/lib/betting/services/score_helper.rb
// betty_web/app/helpers/bet_helper.rb
// betty_web/app/views/sandbox/sandbox/championshipbet.html.haml


export const NUMBER_OF_RANKS = 13
export const TOTAL_PICKS =  NUMBER_OF_RANKS

export const pickIsSet = (pick: ChampionshipBetPick) => !!pick && pick !== "0" && pick !== 0

export const getRound = (
    picks: ChampionshipBetPick[] | undefined,
    teams: (ChampionshipBetTeam | null)[],
    points: PickValue[],
    event_state: TChampionshipBet["event_state"],
) => {
    const pickIndices =  range(0, NUMBER_OF_RANKS) // range(ROUND3_OFFSET, ROUND3_OFFSET + NUMBER_OF_RANKS)
    const currentPick = (index: number) => picks?.[pickIndices[index]]
    const findTeam = (index: number) => teams.find((team) => currentPick(index) === team?.id)
    const round3Points = points.slice(0)
    const pointsSum: PickValue = some(round3Points, (point) => !!point || point === 0) ? sum(round3Points) : undefined
    const getOptions = () => teams

    return {
        getOptions,
        ranking: picks?.slice(0,  NUMBER_OF_RANKS),
        ranks: range(0, NUMBER_OF_RANKS),
        pickedPercent: roundPickPercent(picks),
        pickIndices,
        currentPick,
        findTeam,
        isCorrect: (index: number) => points?.[index] === -1,
        isOpen: event_state === "open",
        points: pointsSum,
    }
}

const roundPickPercent = (picks: ChampionshipBetPick[] | undefined) => {
    return Math.floor(filter(picks?.slice(0), pickIsSet).length / NUMBER_OF_RANKS * 100)
}

export const buildPicks = (item: ChampionshipBetTeam, prev: ChampionshipBetPick[], pickIndices: number[], pickIndex: number, resetIndices?: number[]) => {
    const swapBuffer = prev[pickIndex]
    const swapIndex = pickIndices.find((pi) => {
        return prev[pi] === item?.id
    })
    const newPicks = prev.concat()
    newPicks[pickIndex] = item?.id || undefined
    if (swapIndex !== undefined) {
        newPicks[swapIndex] = swapBuffer
    }
    if (resetIndices) {
        for (let resetIndex of resetIndices) {
            if (prev[resetIndex] === item.id) {
                newPicks[resetIndex] = undefined
            }
            if ((swapIndex || swapIndex === 0) && prev[resetIndex] === prev[swapIndex]) {
                newPicks[resetIndex] = undefined
            }
        }
    }
    return newPicks
}

export const getOverview = (picks: ChampionshipBetPick[] | undefined) => {
    return {
        pickedPercent: roundPickPercent(picks),
    }
}
